import Vue from 'vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
import get from 'lodash/get'
import errorProcessor from '@frontend/ll-fe-tracker/errorProcessor'
import { getGraphQLErrorMessage } from '~/utils/error'
import { ORG_KEYWORDS } from '~/store/organisation'

export default ({ store }, inject) => {
  // Current role of user
  const { role, userId } = store.state.profile.userProfile
  const { schoolProfile } = store.state.school
  const isSuper = store.getters['profile/isSuper']

  inject('CURRENT_USER_ROLE', role)
  inject('CURRENT_USER_ID', +userId)
  inject('USER_SCHOOL_ID', +get(schoolProfile, 'id'))
  inject('IS_SUPER_ROLE', isSuper)

  inject('getGraphQLErrorMessage', (error) => getGraphQLErrorMessage(error))
}

Vue.mixin({
  data: () => {
    return {
      ORG_KEYWORDS,
    }
  },
  computed: {
    ...mapGetters({
      schoolOrgId: 'school/schoolOrgId',
      titlesByOrg: 'organisation/titlesByOrg',
      titlesLoading: 'organisation/titlesLoading',
      keywordsByOrg: 'organisation/keywordsByOrg',
      featuresByOrg: 'organisation/featuresByOrg',
    }),
    orgKeywords() {
      if (this.schoolOrgId && !this.keywordsByOrg) return {}
      return this.keywordsByOrg(this.schoolOrgId) || {}
    },
    orgTitles() {
      return this.titlesByOrg(this.schoolOrgId)
    },
    orgFeatures() {
      return this.featuresByOrg(this.schoolOrgId)
    },
  },
  methods: {
    dateFormat(date, format) {
      return date && moment(date).isValid() ? moment(date).format(format) : ''
    },
    get(object, path, defaultValue) {
      return get(object, path, defaultValue)
    },
    showError(error) {
      errorProcessor.capture(error)
      this.$buefy.notification.open({
        duration: 3000,
        message: this.$t(error || "There's error occurred. Please try again later."),
        type: 'is-danger',
      })
    },
  },
})
